<template>
  <Upload ref="upload" :before-upload="handleBeforeUpload" :on-success="handleSuccess" :headers="headers" :format="format" :action="action">
    <Button>{{ btnText || $t('btn.choose') }}</Button>
  </Upload>
</template>

<script>
  import utils from 'neo-utils';
  export default {
    name: 'FileUpoad',
    data() {
      return {
        headers: {},
        file: '',
      };
    },
    props: {
      action: {
        type: String,
        default: '',
      },
      maxSize: {
        type: Number,
        default: 5, //默认5M，单位：M
      },
      format: {
        type: Array,
        default() {
          return ['doc', 'docx', 'xls', 'xlsx', 'txt', 'pdf', 'jpg', 'png'];
        },
      },
      btnText: {
        type: String,
        default: '',
      },
      // 手动上传
      manual: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      /**
       * 上传开始之前，校验文件格式及大小
       * @author 李彦
       * @date 2021-04-29
       * @param {object} file 上传文件
       * @returns {void}
       */
      handleBeforeUpload(file) {
        this.file = file;
        const fileNameArray = file.name.split('.');
        const fileType = fileNameArray.pop();

        if (!this.format.includes(fileType)) {
          // 格式校验
          this.$Message.warning(this.$i18n.t('page.fileTypes', [this.format.join(',')]));
          return false;
        }
        if (file.size / 1024000 > this.maxSize) {
          // 大小校验
          this.$Message.warning(this.$i18n.t('page.maxFileSize', [`${this.maxSize}M`]));
          return false;
        }
        this.clearFiles();
        const headers = utils.business.getHeader();
        Object.assign(this.headers, headers);
        if (this.manual) {
          return false;
        }
      },
      /**
       * 上传成功回调方法
       * @author 李彦
       * @date 2021-04-29
       * @param {object} resp 接口返回值
       * @returns {void}
       */
      handleSuccess(resp) {
        if (resp.code == process.env.VUE_APP_code) {
          this.$emit('on-success', resp.response);
        } else {
          this.$Message.error(resp.message);
          this.$emit('on-success', '');
          this.clearFiles();
        }
      },
      /**
       * 清空附件列表
       * @author 李彦
       * @date 2021-04-29
       * @returns {void}
       */
      clearFiles() {
        this.$refs.upload.clearFiles();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
